import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Chat = () => (
	<div>
	chat
	</div>
);

export default Chat;



// WEBPACK FOOTER //
// ./components/chat/index.js